
import { defineComponent, ref, toRaw } from 'vue';
import { useRoute } from 'vue-router';
import type { ISsoDetailRes } from '@/api/message-center/type.d';
import {
  getSsoInfo,
} from '@/api/message-center';
import { formatTime } from '@toy/utils';
import MonacoEditor from '@/components/monaco-editor/index.vue';

export default defineComponent({
  components: {
    MonacoEditor,
  },
  setup() {
    const $route = useRoute();
    const ssoLogId = $route.params.id as string;
    const ssoDetail = ref({} as ISsoDetailRes);
    /**
     * 请求详情数据
     */
    const getSsoDetail = async () => {
      const { data } = await getSsoInfo(ssoLogId);
      ssoDetail.value = data;
    };
    const detailDialogInfo = ref({
      visible: false,
      value: '',
      title: '',
      options: {
        language: 'json',
      },
    });
    /**
     *处理查看详情数据
     * @param key
     * @param title
     */
    const handleShowDetail = (key: keyof ISsoDetailRes, title: string) => {
      let value = toRaw(ssoDetail.value[key]);
      if (typeof value !== 'string') {
        try {
          value = JSON.stringify(value);
          detailDialogInfo.value.options.language = key === 'stackTrace' ? 'java' : 'json';
        } catch (e) {
          value = '';
          console.error(e);
        }
      }
      detailDialogInfo.value.visible = true;
      detailDialogInfo.value.value = value;
      detailDialogInfo.value.title = title;
    };
    const SsoDetailKeyMap = {
      logId: {
        label: 'ID',
      },
      successful: {
        label: '是否成功',
        formatter: (value: boolean) => (value ? '成功' : '失败'),
      },
      requestUrl: {
        label: '请求地址',
      },
      requestTime: {
        label: '请求时间',
        formatter: (value: string) => formatTime(value),
      },
      responseTime: {
        label: '响应时间',
        formatter: (value: string) => formatTime(value),
      },
      executeTime: {
        label: '执行时间(ms)',
      },
      code: {
        label: '响应CODE',
      },
      message: {
        label: '响应消息',
      },
      creatorName: {
        label: '用户名',
      },
      token: {
        label: '用户TOKEN',
      },
    };
    const init = () => {
      getSsoDetail();
    };
    init();
    return {
      SsoDetailKeyMap,
      getSsoDetail,
      ssoDetail,
      detailDialogInfo,
      handleShowDetail,

    };
  },
});
